import {Money} from '@dms/api/shared';

export type ListLatestBusinessCasesApiResponse =
  /** status 200  */ DashboardBusinessCaseResponseBody[];
export type ListLatestBusinessCasesApiArg = {
  branchId?: string;
};
export type ListLatestInterestsApiResponse = /** status 200  */ DashboardInterestResponseBody[];
export type ListLatestInterestsApiArg = {
  branchId?: string;
};
export type ListLatestVehiclesApiResponse = /** status 200  */ DashboardVehicleResponseBody[];
export type ListLatestVehiclesApiArg = {
  branchId?: string;
};
export type GetPurchaseFunnelApiResponse = /** status 200  */ PurchaseFunnelResponseBody;
export type GetPurchaseFunnelApiArg = {
  branchId?: string;
  onlyMine?: boolean;
};
export type GetSaleFunnelApiResponse = /** status 200  */ SaleFunnelResponseBody;
export type GetSaleFunnelApiArg = {
  branchId?: string;
  onlyMine?: boolean;
};
export type GetVehicleStockOverviewApiResponse =
  /** status 200  */ VehicleStockOverviewResponseBody;
export type GetVehicleStockOverviewApiArg = {
  branchId?: string;
};
export type DashboardTagResponseBody = {
  label: string;
  color: string;
};
export type DashboardBusinessCaseResponseBody = {
  id: string;
  customer: string;
  vehicle: string | null;
  price: Money | null;
  type: string | null;
  state: string;
  tradeType: string | null;
  tags: DashboardTagResponseBody[];
  assignees: string[];
  owner: string | null;
};
export type DashboardInterestResponseBody = {
  id: string;
  customer: string;
  vehicle: string | null;
  type: string;
  state: string;
  source: string | null;
  tags: DashboardTagResponseBody[];
  assignees: string[];
  owner: string | null;
};
export type DashboardVehicleResponseBody = {
  id: string;
  imageUrl: string | null;
  title: string | null;
  manufacturedOn: string | null;
  mileage: string | null;
  fuelType: string | null;
  transmission: string | null;
  price: Money | null;
  priceWithVat: Money | null;
  priceWithoutVat: Money | null;
  isVatDeductible: boolean | null;
  isArchived: boolean | null;
  isReserved: boolean | null;
  saleType: string | null;
  buyingState: string | null;
  sellingState: string | null;
  isAdvertised: boolean | null;
  isPhotographed: boolean | null;
  tags: DashboardTagResponseBody[];
};
export type PurchaseFunnelResponseBody = {
  newInterests: number;
  activeInterests: number;
  offers: number;
  contracts: number;
  bought: number;
  closed: number;
};
export type SaleFunnelResponseBody = {
  newInterests: number;
  activeInterests: number;
  offers: number;
  contracts: number;
  sold: number;
  closed: number;
};
export type VehicleStockOverviewResponseBody = {
  totalForSale: number;
  selling: number;
  buying: number;
  motExpirationWarning: number;
  motExpiredWarning: number;
};
